import { SVGProps } from 'react';

export const Refresh = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='12'
      height='13'
      viewBox='0 0 12 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.37771 5.52957C2.91374 3.52907 4.97 2.34189 6.9705 2.87792C7.63099 3.0549 8.20189 3.39699 8.65182 3.84776L9.60336 4.7993H8.0115C7.80439 4.7993 7.6365 4.96719 7.6365 5.1743C7.6365 5.3814 7.80439 5.5493 8.0115 5.5493H10.5078C10.6073 5.5493 10.7027 5.50978 10.773 5.43944C10.8433 5.36911 10.8828 5.27371 10.8828 5.17424V2.678C10.8828 2.47089 10.7149 2.303 10.5078 2.303C10.3007 2.303 10.1328 2.47089 10.1328 2.678V4.26808L9.18265 3.31793C8.64207 2.77639 7.95581 2.36547 7.16461 2.15347C4.76402 1.51024 2.2965 2.93486 1.65326 5.33545C1.59966 5.5355 1.71838 5.74113 1.91843 5.79473C2.11848 5.84834 2.3241 5.72962 2.37771 5.52957ZM10.0814 7.20555C9.88138 7.15194 9.67575 7.27066 9.62215 7.47071C9.08612 9.47121 7.02985 10.6584 5.02936 10.1224C4.36887 9.94538 3.79797 9.6033 3.34805 9.15253L2.3971 8.20097H3.98851C4.19561 8.20097 4.36351 8.03307 4.36351 7.82597C4.36351 7.61886 4.19561 7.45097 3.98851 7.45097L1.49219 7.45097C1.28508 7.45097 1.11719 7.61886 1.11719 7.82597V10.3223C1.11719 10.5294 1.28508 10.6973 1.49219 10.6973C1.69929 10.6973 1.86719 10.5294 1.86719 10.3223V8.73171L2.81722 9.68237C3.35782 10.224 4.04398 10.6348 4.83524 10.8468C7.23584 11.49 9.70336 10.0654 10.3466 7.66483C10.4002 7.46478 10.2815 7.25915 10.0814 7.20555Z'
      />
    </svg>
  );
};
